import React, { Fragment } from 'react'
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen'

import './ContentCard.scss'

const ContentCardDemo = ({ data }) => {
    console.log('ContentCardDemo data: ', data)
    // console.log('ContentCardDemo useCheckMobileScreen: ', useCheckMobileScreen())

    const isMobile = useCheckMobileScreen()
    return (

        <Fragment>
            {data ? (
            <div className="content-card-outer">
                <div className="content-card-inner">

                        {isMobile ? (
                            <div className="cc-mobile">
                                <a href={data.link} target="_blank" rel="noopener noreferrer" title={data.title}>
                                <img src={data.imageMobile} alt={data.imageAlt} />
                                </a>
                            </div>
                        ) : (
                            <div className="cc-desktop">
                                <a href={data.link} target="_blank" rel="noopener noreferrer" title={data.title}>
                                    <img src={data.imageDesktop} alt={data.imageAlt} />
                                </a>
                            </div>
                        )}



                </div>
            </div>

        ) : (
            <div className="cc-no-data">
                <p>No data</p>
            </div>
        )}
        </Fragment>
    )
}

export default ContentCardDemo
